"use client";
import React, { useEffect } from "react";
import { routes } from "@/app/configs/routes";
import { h } from "@/app/helpers";

export default function Home() {
    useEffect(() => {
        let accessToken = h.cookie.getAccessToken();
        if (h.general.notEmpty(accessToken)) {
            window.location = routes.profile;
        } else {
            window.location = routes.login;
        }
    }, []);
    return <html className=""></html>;
}
